import React from 'react';
import ProfileBar from '../profiles/Components/ProfileBar';
import Verification from '../assets/img/verification_icon.png';
import Union from '../assets/img/union.png';
import Reward from '../assets/img/reward_icon.png';
import Loader from '../components/Loader';
import Card from './components/Card';
import { useShowKhelo } from '../../src/utils/HooksUtils';
import { useVerificationDetails } from './queries/actHooks';
import { useUserProfile } from '../profiles/queries/profileHooks';
// import { getDateInDDMMYYYY } from '../constants/DateFunctions';
// import Helmet from 'react-helmet';
function Collection(props) {
  const { data: profile } = useUserProfile();

  const { data, isLoading } = useVerificationDetails({
    user_id: profile.message.sfa_id,
  });

  const isKhelo = useShowKhelo();
  // console.log(data);
  return (
    <div>
      {/* <Helmet>
        <title>Accred & Sports Kits | KIYG Haryana 2021</title>
        <meta
          name="description"
          content="Here's all the information regarding your Accreditation (i.e. ID Cards) & Sports Kits at the #KIYG2021. Wish you all the very best!"
        />
        <meta property="og:title" content="Accred & Sports Kits | KIYG Haryana 2021" />
        <meta
          property="og:description"
          content="Here's all the information regarding your Accreditation (i.e. ID Cards) & Sports Kits at the #KIYG2021. Wish you all the very best!"
        />
      </Helmet> */}
      {!isKhelo && <ProfileBar head="Verification & Collection" act={true} />}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {isKhelo ? (
            <div className={`mt-6 flex gap-3 flex-col mb-5`}>
              {profile?.message?.primary_role === 'athlete' && (
                <div className="md:flex gap-3">
                  {false && (
                    <Card
                      firstCol={true}
                      heading="Physical Verification"
                      status={
                        data?.physical_verification?.status === 'Verification Completed'
                          ? data?.physical_verification?.status
                          : 'Pending'
                      }
                      contentHeader="Verification Remark"
                      content={
                        data?.physical_verification?.remark &&
                        data?.physical_verification?.remark.length
                          ? data?.physical_verification?.remark
                          : data?.physical_verification?.status !== 'Verification Completed'
                          ? 'Information to be updated shortly.'
                          : '-'
                      }
                      icon={Verification}
                      location={
                        data?.physical_verification?.location &&
                        data?.physical_verification?.location
                      }
                    />
                  )}

                  <Card
                    heading="Accreditation"
                    // date={data?.accredition?.date ? getDateInDDMMYYYY(data?.accredition?.date) : '-'}
                    status={
                      data?.accredition?.status
                        ? data?.accredition?.status === 'Accred Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Accreditation Remark"
                    content={
                      data?.accredition?.remark && data?.accredition?.remark.length
                        ? data?.accredition?.remark
                        : data?.accredition?.status !== 'Accred Given'
                        ? 'Information to be updated once your ACCREDITATION IS COLLECTED'
                        : '-'
                    }
                    icon={Reward}
                    location={data?.accredition?.location && data?.accredition?.location}
                    locationText={'Accreditation Center'}
                  />
                </div>
              )}
              <div className="md:flex gap-3">
                {profile?.message?.primary_role !== 'athlete' && (
                  <Card
                    heading="Accreditation"
                    // date={data?.accredition?.date ? getDateInDDMMYYYY(data?.accredition?.date) : '-'}
                    status={
                      data?.accredition?.status
                        ? data?.accredition?.status === 'Accred Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Accreditation Remark"
                    content={
                      data?.accredition?.remark && data?.accredition?.remark.length
                        ? data?.accredition?.remark
                        : data?.accredition?.status !== 'Accred Given'
                        ? 'Information to be updated once your ACCREDITATION IS COLLECTED'
                        : '-'
                    }
                    icon={Reward}
                    location={data?.accredition?.location && data?.accredition?.location}
                    locationText={'Accreditation Center'}
                  />
                )}
                {profile?.message?.primary_role === 'Volunteer' && (
                  <Card
                    firstCol={true}
                    heading="Generic Kit"
                    status={
                      data?.sports_kit?.status
                        ? data?.sports_kit?.status === 'Sports Kit Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Kit Remark"
                    content={
                      data?.sports_kit?.remark && data?.sports_kit?.remark.length
                        ? data?.sports_kit?.remark
                        : data?.sports_kit?.status !== 'Sports Kit Given'
                        ? 'Information to be updated once your SPORTS KIT IS COLLECTED'
                        : '-'
                    }
                    location={data?.sports_kit?.location && data?.sports_kit?.location}
                    icon={Union}
                    locationText={'Kit Location'}
                  />
                )}
                {false && (
                  <Card
                    heading="Sports Specific Kit"
                    status={
                      data?.sports_specific_kit?.status
                        ? data?.sports_specific_kit?.status === 'Sports Specific Kit Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Sports Kit Remark"
                    content={
                      data?.sports_specific_kit?.remark && data?.sports_specific_kit?.remark.length
                        ? data?.sports_specific_kit?.remark
                        : data?.sports_specific_kit?.status !== 'Sports Specific Kit Given'
                        ? 'Information to be updated once your SPORTS SPECIFIC KIT IS COLLECTED'
                        : '-'
                    }
                    icon={Union}
                    location={
                      data?.sports_specific_kit?.location && data?.sports_specific_kit?.location
                    }
                    locationText={'Sports Kit Location'}
                  />
                )}
              </div>
              {/* <div className="md:flex">
                {profile?.message?.primary_role !== 'coach' && (
                  <Card
                    firstCol={true}
                    heading="Generic Kit"
                    status={
                      data?.sports_kit?.status
                        ? data?.sports_kit?.status === 'Sports Kit Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Kit Remark"
                    content={
                      data?.sports_kit?.remark && data?.sports_kit?.remark.length
                        ? data?.sports_kit?.remark
                        : data?.sports_kit?.status !== 'Sports Kit Given'
                        ? 'Information to be updated once your SPORTS KIT IS COLLECTED'
                        : '-'
                    }
                    location={data?.sports_kit?.location && data?.sports_kit?.location}
                    icon={Union}
                    locationText={'Kit Location'}
                  />
                )}
                {profile?.message?.primary_role !== 'coach' && (
                  <Card
                    heading="Sports Specific Kit"
                    status={
                      data?.sports_specific_kit?.status
                        ? data?.sports_specific_kit?.status === 'Sports Specific Kit Given'
                          ? 'Collected'
                          : 'Pending'
                        : 'Pending'
                    }
                    contentHeader="Sports Kit Remark"
                    content={
                      data?.sports_specific_kit?.remark && data?.sports_specific_kit?.remark.length
                        ? data?.sports_specific_kit?.remark
                        : data?.sports_specific_kit?.status !== 'Sports Specific Kit Given'
                        ? 'Information to be updated once your SPORTS SPECIFIC KIT IS COLLECTED'
                        : '-'
                    }
                    icon={Union}
                    location={
                      data?.sports_specific_kit?.location && data?.sports_specific_kit?.location
                    }
                    locationText={'Sports Kit Location'}
                  />
                )}
              </div> */}
            </div>
          ) : (
            <div className={`mx-6 mt-6  mb-5 flex flex-col gap-6`}>
              <Card
                heading="Physical Verification"
                status={data?.physical_verification?.status}
                contentHeader="Remark"
                content={data?.physical_verification?.remark}
                icon={Verification}
                // date={
                //   data?.physical_verification?.date
                //     ? getDateInDDMMYYYY(data?.physical_verification?.date)
                //     : '-'
                // }
              />
              <Card
                heading="Accreditation"
                status={data?.accredition?.status}
                contentHeader="Remark"
                content={data?.accredition?.remark}
                icon={Reward}
                // date={data?.accredition?.date ? getDateInDDMMYYYY(data?.accredition?.date) : '-'}
                locationText={'Accreditation Center'}
              />
              <Card
                heading="Sports Kit"
                status={data?.sports_kit?.status}
                contentHeader="Remark"
                content={data?.sports_kit?.remark}
                icon={Union}
                // date={data?.sports_kit?.date ? getDateInDDMMYYYY(data?.sports_kit?.date) : '-'}
                sportSpecificKit={data?.sports_specific_kit}
                locationText={'Sports Kit Location'}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Collection;
